/** @format */

import { useRef } from "react";
import Layout from "../components/Layout";
import ChatInterfaceNew from "../pages/chat";

/** Stable route shell — must live outside App() so chat UI is not remounted on every state change. */
export default function ChatsRoute({
  userName,
  hasMoreChats,
  onLoadMoreChats,
  chatsLoadingMore,
  ...chatProps
}) {
  const sidebarToggleRef = useRef(null);

  return (
    <Layout
      title="Chats"
      userName={userName}
      hideMobileHeader
      onSidebarToggleRef={sidebarToggleRef}
      hasMoreChats={hasMoreChats}
      onLoadMoreChats={onLoadMoreChats}
      loadingMoreChats={chatsLoadingMore}
    >
      <ChatInterfaceNew
        {...chatProps}
        hasMoreChats={hasMoreChats}
        chatsLoadingMore={chatsLoadingMore}
        onLoadMoreChats={onLoadMoreChats}
        onToggleSidebar={() => {}}
        onMenuClick={() => sidebarToggleRef.current?.()}
      />
    </Layout>
  );
}
